module.exports = __webpack_public_path__ + "img/SKMJ_train6.3e962df9.jpg";